<template>
  <v-container fluid class="pt-0">
      <HeaderListaPlanejamentoEcomm
          titulo="Mapeamento Pacote"
          :pesquisa.sync="pesquisa"
          @exportar="exportar"
          @importar="abrirImportacao"
          hide-cadastrar
      />

      <v-card class="px-5 py-5 br-15 w-100 mt-5" elevation="0">
          <v-data-table
              class="elevation-0 tabela"
              :headers="headers"
              :items="dados"
              :items-per-page="10"
              :footer-props="tableConfig"
              :header-props="{ sortIcon: 'mdi-chevron-down' }"
              :search="pesquisa"
              v-model="selecionado"
              item-key="id_mapeamento_pacote"
              multi-sort
          >
              <template v-slot:[`item.acoes`]="{ item }">
                  <v-btn
                      icon
                      color="primary"
                      @click="editar(item)"
                  >
                      <v-icon>mdi-pencil</v-icon>
                  </v-btn>
              </template>
          </v-data-table>
          <div class="table-footer-prepend">
              <v-btn
                  color="error"
                  class="new-button mt-3"
                  v-if="selecionado.length > 0"
                  dark
                  @click="excluir(selecionado)"
              >
                  Excluir selecionados
              </v-btn>
          </div>
      </v-card>
      <v-overlay :value="carregando" :z-index="300">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-dialog
          content-class="br-15"
          scrollable
          v-model="dialogoExcluir"
          width="600"
      >
          <v-card>
              <v-toolbar
                  elevation="0"
                  dark
                  class="error white--text fix-flex"
              >
                  <v-toolbar-title> Excluir Mapeamento</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn
                      fab
                      width="24px"
                      height="24px"
                      elevation="0"
                      light
                      @click="dialogoExcluir = false"
                  >
                      <v-icon size="20px" color="error">mdi-close</v-icon>
                  </v-btn>
              </v-toolbar>
              <v-card-text class="pa-5">
                  Deseja realmente <span style="color: red">excluir</span>
                  {{ listaExclusao.length }}
                  {{ listaExclusao.length === 1 ? 'registro' : 'registros' }}?
                  <br />
                  <br />
              </v-card-text>
              <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                      color="error"
                      class="new-button mr-3 px-4 mb-4"
                      @click="dialogoExcluir = false"
                  >
                      <v-icon class="mr-3">mdi-close-circle</v-icon>

                      Não, não quero exluir
                  </v-btn>
                  <v-btn
                      class="new-button px-4 mb-4 mr-4"
                      color="primary"
                      @click="confirmarExclusao()"
                  >
                      <v-icon class="mr-3">mdi-check-circle</v-icon>
                      Sim, quero excluir
                  </v-btn>
              </v-card-actions>
          </v-card>
      </v-dialog>
      <v-dialog content-class="br-15" v-model="dialogoForm" width="600">
          <v-card>
              <v-toolbar
                  elevation="0"
                  dark
                  class="primary-degrade white--text fix-flex"
              >
                  <v-toolbar-title
                      >{{
                          form.id_mapeamento_pacote ? 'Editar' : 'Cadastrar'
                      }}
                      Mapeamento Pacote</v-toolbar-title
                  >
                  <v-spacer></v-spacer>
                  <v-btn
                      fab
                      width="24px"
                      height="24px"
                      elevation="0"
                      light
                      @click="dialogoForm = false"
                  >
                      <v-icon size="18px" color="primary">mdi-close</v-icon>
                  </v-btn>
              </v-toolbar>
              <v-card-text class="pa-5">
                  <v-form ref="form">
                      <v-alert class="mb-4" v-if="alerta" dark color="error">
                          {{ alertaMensagem }}
                      </v-alert>
                      <v-row class="pt-4">
                          <v-col cols="12" class="my-0 py-0">
                              <v-autocomplete
                                  label="Fornecedor"
                                  v-model="form.id_fornecedor"
                                  :items="fornecedores"
                                  item-text="nome"
                                  item-value="id_fornecedor"
                                  class="input-cinza"
                                  :rules="regra.id_fornecedor"
                                  :menu-props="menuProps"
                                  outlined
                                  dense
                                  @change="carregarPlanosPacotes"
                              ></v-autocomplete>
                          </v-col>
                          <v-col cols="12" class="my-0 py-0">
                              <v-autocomplete
                                  label="Plano/Pacote"
                                  v-model="form.id_plano_pacote"
                                  :items="planosPacotes"
                                  item-text="nome"
                                  item-value="id_plano_pacote"
                                  class="input-cinza"
                                  :rules="regra.id_plano_pacote"
                                  :menu-props="menuProps"
                                  :disabled="!form.id_fornecedor"
                                  outlined
                                  dense
                              >
                                  <template v-slot:item="{ item }">
                                      <v-list-item-content>
                                          <v-list-item-title>{{ item.plano }} - {{ item.pacote }}</v-list-item-title>
                                      </v-list-item-content>
                                  </template>
                                  <template v-slot:selection="{ item }">
                                      {{ item.plano }} - {{ item.pacote }}
                                  </template>
                              </v-autocomplete>
                          </v-col>
                          <v-col cols="12" class="my-0 py-0">
                              <v-text-field
                                  label="Planejamento Plano"
                                  v-model="form.planejamento_plano"
                                  class="input-cinza"
                                  :rules="regra.planejamento_plano"
                                  outlined
                                  dense
                              ></v-text-field>
                          </v-col>

                          <v-col class="d-flex justify-end">
                              <v-btn
                                  color="primary"
                                  class="ml-auto new-button"
                                  @click="salvar()"
                              >
                                  <v-icon left>mdi-check-circle</v-icon>
                                  Salvar
                              </v-btn>
                          </v-col>
                      </v-row>
                  </v-form>
              </v-card-text>
          </v-card>
      </v-dialog>
        <Importacao 
            v-model="dialogoImportacao" 
            @filtrar="filtrar"
            @exportar="exportar"
         />
  </v-container>
</template>

<script>
import HeaderListaPlanejamentoEcomm from '@/views/planejamento_ecommerce/cadastro_plano_pacote/_components/headerListaPlanejamentoEcomm.vue'
import Importacao from './Importacao.vue'

export default {
  name: 'mapeamento_pacote',
  components: {
      HeaderListaPlanejamentoEcomm,
      Importacao
  },

  data() {
      return {
          menuProps: {
              bottom: true,
              offsetY: true,
              contentClass: 'select-outline',
              transition: 'slide-y-transition',
          },
          selecionado: [],
          carregando: false,
          pesquisa: '',
          dialogo: false,
          dialogoForm: false,
          dialogoExcluir: false,
          dialogoImportacao: false,
          alertaMesagem: '',
          alerta: false,
          listaExclusao: [],
          alertaMensagem: '',
          fornecedores: [],
          planosPacotes: [],
          form: {
              id_mapeamento_pacote: null,
              id_fornecedor: null,
              id_plano_pacote: null,
              planejamento_plano: null,
          },
          tableConfig: {
              itemsPerPageOptions: [5, 10, 20, 50, 100, -1],
              itemsPerPageText: 'Linhas por páginas',
              ofText: 'de',
              pageText: '{0}-{1} de {2}',
          },
          dados: [],
          regra: {
              id_fornecedor: [(v) => !!v || 'Campo Fornecedor é obrigatório.'],
              id_plano_pacote: [(v) => !!v || 'Campo Plano/Pacote é obrigatório.'],
              planejamento_plano: [(v) => !!v || 'Campo Planejamento Plano é obrigatório.'],
          },
          headers: [
              {
                  text: 'ID',
                  value: 'id_mapeamento_pacote',
                  class: 'th-separador min-width-80',
                  align: 'center',
              },
              {
                  text: 'Código Fornecedor',
                  value: 'codigo_fornecedor',
                  class: 'th-separador min-width-120',
                  align: 'center',
              },
              {
                  text: 'Fornecedor',
                  value: 'fornecedor',
                  class: 'th-separador min-width-200',
                  align: 'left',
              },
              {
                  text: 'Plano',
                  value: 'plano',
                  class: 'th-separador min-width-150',
                  align: 'left',
              },
              {
                  text: 'Pacote',
                  value: 'pacote',
                  class: 'th-separador min-width-200',
                  align: 'left',
              },
              {
                  text: 'Planejamento Plano',
                  value: 'planejamento_plano',
                  class: 'th-separador min-width-200',
                  align: 'left',
              },
              {
                  text: 'Ações',
                  value: 'acoes',
                  class: 'th-separador min-width-100',
                  align: 'center',
                  sortable: false,
              }
          ],
      }
  },

  created() {
      this.filtrar()
      this.carregarFornecedores()
  },
  methods: {
      async carregarFornecedores() {
          try {
              const response = await this.$http().post(
                  "/planejamentoEcommerce/fornecedor/lista",
                  {}
              );
              if (response.data.data && response.data.data.length > 0) {
                  this.fornecedores = response.data.data
              }
          } catch (error) {
              console.error('Erro ao carregar fornecedores:', error)
          }
      },
      async carregarPlanosPacotes() {
          if (!this.form.id_fornecedor) {
              this.planosPacotes = []
              return
          }
          try {
              const response = await this.$http().post(
                  "/planejamentoEcommerce/plano-pacote/lista",
                  { id_fornecedor: this.form.id_fornecedor }
              );
              if (response.data.data && response.data.data.length > 0) {
                  this.planosPacotes = response.data.data
              } else {
                  this.planosPacotes = []
              }
          } catch (error) {
              console.error('Erro ao carregar planos/pacotes:', error)
              this.planosPacotes = []
          }
      },
      novo() {
          this.resetarForm()
          this.dialogoForm = true
      },
      async editar(item) {
          this.form.id_mapeamento_pacote = item.id_mapeamento_pacote
          this.form.id_fornecedor = item.id_fornecedor
          this.form.planejamento_plano = item.planejamento_plano
          await this.carregarPlanosPacotes()
          this.form.id_plano_pacote = item.id_plano_pacote
          this.dialogoForm = true
      },
      async salvar() {
          if (!this.$refs.form.validate()) return
          
          const data = {
              id_mapeamento_pacote: this.form.id_mapeamento_pacote,
              id_fornecedor: this.form.id_fornecedor,
              id_plano_pacote: this.form.id_plano_pacote,
              planejamento_plano: this.form.planejamento_plano,
          }

          const response = await this.$http().post(
              "/planejamentoEcommerce/mapeamento-pacote/salvar",
              data
          );

          if (response.status == 200) {
              this.$dialog.notify.success('Mapeamento salvo com sucesso!')
              this.dialogoForm = false
              this.filtrar()
          } else {
              this.$dialog.notify.error(
                  response.data.mensagem || 'Erro ao salvar Mapeamento!'
              )
          }
      },
      excluir(itens) {
          this.listaExclusao = itens
          this.dialogoExcluir = true
      },
      async confirmarExclusao() {
          const data = {
              ids: this.listaExclusao.map((item) => item.id_mapeamento_pacote),
          }

          const response = await this.$http().post(
              "/planejamentoEcommerce/mapeamento-pacote/excluir",
              data
          );

          if (response.status == 200) {
              this.$dialog.notify.success('Mapeamento excluído com sucesso!')
              this.dialogoExcluir = false
              this.selecionado = []
              this.listaExclusao = []

              this.filtrar()
          } else {
              this.$dialog.notify.error(
                  response.data.mensagem || 'Erro ao excluir Mapeamento!'
              )
          }
      },

      resetarForm() {
          try {
              this.$refs.form.resetValidation()
          } catch (error) {
              console.log(error)
          }

          this.form = {
              id_mapeamento_pacote: null,
              id_fornecedor: null,
              id_plano_pacote: null,
              planejamento_plano: null,
          };
          this.planosPacotes = [];
      },
      async exportar() {
          const data = {};
          const response = await this.$http().post(
              "/planejamentoEcommerce/mapeamento-pacote/exportar",
              data
          );

          if (response.status == 200) {
              this.$dialog.notify.success('Mapeamento exportado com sucesso!')
              window.location = this.$http('baseURL') + response.data.url
          } else {
              this.$dialog.notify.error(
                  response.data.mensagem || 'Erro ao exportar Mapeamento!'
              )
          }
      },
      abrirImportacao() {
          this.dialogoImportacao = true
      },
      async filtrar() {
          this.carregando = true;
          const data = {};
          const response = await this.$http().post(
              "/planejamentoEcommerce/mapeamento-pacote/lista",
              data
          );

          if (response.data.data && response.data.data.length > 0) {
              this.dados = response.data.data
          } else {
              this.dados = []
          }
          this.carregando = false
      },
  },
}
</script>
